import { createAction, props } from "@ngrx/store";
import { BasicXpacInfo, DetailedXpacInfo, LocationHandle, Address, UpgradeData, RemoteFirmwareInformation, Release, FirmwareInfoPatch, DeviceLogPageResponse } from "src/app/generated/CrossPoint.RemoteXpac.Server";
import { ApiPermissions } from "src/app/utils/interfaces/auth.interfaces";
import { IDataAction } from "src/app/utils/interfaces/common.interfaces";
import { IGetDevicesData, IGetMapDevicesData, IGetRestoreDevicesData, IGetUpgradeData, ISetRestoreDevicesData } from "src/app/utils/interfaces/remote-maintenance.interfaces";
import { IRestoreDevicesXpac, IXpacCompanyInfoState, IPatchStoreState, IProblemState, IRemoteConnectionsState, IDeviceConnectionsState, IGetMenderReleasesState, IDeviceDeployments, ITelemetryState, IGetTelemetry, IXpacDevices, IFirmwareInfoPatch } from "src/app/utils/interfaces/store.interfaces";


export enum DevicesActionsTypes {
  GET_DEVICES = '[DEVICES] GET_DEVICES',
  GET_DEVICES_SUCCESS = '[DEVICES] GET_DEVICES_SUCCESS',
  GET_DEVICES_FAILED = '[DEVICES] GET_DEVICES_FAILED',
  // This one just replays the last GET_DEVICES action
  REFRESH_DEVICES = '[DEVICES] REFRESH_DEVICES',

  GET_UPGRADE_DEVICES = '[DEVICES] GET_UPGRADE_DEVICES',
  GET_UPGRADE_DEVICES_SUCCESS = '[DEVICES] GET_UPGRADE_DEVICES_SUCCESS',
  GET_UPGRADE_DEVICES_FAILED = '[DEVICES] GET_UPGRADE_DEVICES_FAILED',

  GET_RESTORE_DEVICES = '[DEVICES] GET_RESTORE_DEVICES',
  GET_RESTORE_DEVICES_SUCCESS = '[DEVICES] GET_RESTORE_DEVICES_SUCCESS',
  GET_RESTORE_DEVICES_FAILED = '[DEVICES] GET_RESTORE_DEVICES_FAILED',

  GET_MAP_DEVICES = '[DEVICES] GET_MAP_DEVICES',
  GET_MAP_DEVICES_SUCCESS = '[DEVICES] GET_MAP_DEVICES_SUCCESS',
  GET_MAP_DEVICES_FAILED = '[DEVICES] GET_MAP_DEVICES_FAILED',

  SET_RESTORE_DEVICE = '[DEVICES] SET_RESTORE_DEVICE',
  SET_RESTORE_DEVICE_SUCCESS = '[DEVICES] SET_RESTORE_DEVICE_SUCCESS',
  SET_RESTORE_DEVICE_FAILED = '[DEVICES] SET_RESTORE_DEVICE_FAILED',

  GET_DEVICE_PROBLEMS = '[DEVICES] GET_DEVICE_PROBLEMS',
  GET_DEVICE_PROBLEMS_SUCCESS = '[DEVICES] GET_DEVICE_PROBLEMS_SUCCESS',
  GET_DEVICE_PROBLEMS_FAILED = '[DEVICES] GET_DEVICE_PROBLEMS_FAILED',

  GET_DEVICE_LOGGING = '[DEVICES] GET_DEVICE_LOGGING',
  GET_DEVICE_LOGGING_SUCCESS = '[DEVICES] GET_DEVICE_LOGGING_SUCCESS',
  GET_DEVICE_LOGGING_FAILED = '[DEVICES] GET_DEVICE_LOGGING_FAILED',

  GET_REMOTE_CONNECTIONS = '[DEVICES] GET_REMOTE_CONNECTIONS',
  GET_REMOTE_CONNECTIONS_SUCCESS = '[DEVICES] GET_REMOTE_CONNECTIONS_SUCCESS',
  GET_REMOTE_CONNECTIONS_FAILED = '[DEVICES] GET_REMOTE_CONNECTIONS_FAILED',

  GET_DEVICE_CONNECTIONS = '[DEVICES] GET_DEVICE_CONNECTIONS',
  GET_DEVICE_CONNECTIONS_SUCCESS = '[DEVICES] GET_DEVICE_CONNECTIONS_SUCCESS',
  GET_DEVICE_CONNECTIONS_FAILED = '[DEVICES] GET_DEVICE_CONNECTIONS_FAILED',

  GET_DEVICE_COMPANIES = '[DEVICES] GET_DEVICE_COMPANIES',
  GET_DEVICE_COMPANIES_SUCCESS = '[DEVICES] GET_DEVICE_COMPANIES_SUCCESS',
  GET_DEVICE_COMPANIES_FAILED = '[DEVICES] GET_DEVICE_COMPANIES_FAILED',

  SET_DEVICE_COMPANIES = '[DEVICES] SET_DEVICE_COMPANIES',
  SET_DEVICE_COMPANIES_SUCCESS = '[DEVICES] SET_DEVICE_COMPANIES_SUCCESS',
  SET_DEVICE_COMPANIES_FAILED = '[DEVICES] SET_DEVICE_COMPANIES_FAILED',

  GET_STORE_INFO = '[DEVICES] GET_STORE_INFO',
  GET_STORE_INFO_SUCCESS = '[DEVICES] GET_STORE_INFO_SUCCESS',
  GET_STORE_INFO_FAILED = '[DEVICES] GET_STORE_INFO_FAILED',

  SET_STORE_INFO = '[DEVICES] SET_STORE_INFO',
  SET_STORE_INFO_SUCCESS = '[DEVICES] SET_STORE_INFO_SUCCESS',
  SET_STORE_INFO_FAILED = '[DEVICES] SET_STORE_INFO_FAILED',

  GET_LOCATION_AUTOCOMPLETE = '[DEVICES] GET_LOCATION_AUTOCOMPLETE',
  GET_LOCATION_AUTOCOMPLETE_SUCCESS = '[DEVICES] GET_LOCATION_AUTOCOMPLETE_SUCCESS',
  GET_LOCATION_AUTOCOMPLETE_FAILED = '[DEVICES] GET_LOCATION_AUTOCOMPLETE_FAILED',

  GET_LOCATION_DATA_BY_ADDRESS = '[DEVICES] GET_LOCATION_DATA_BY_ADDRESS',
  GET_LOCATION_DATA_BY_ADDRESS_SUCCESS = '[DEVICES] GET_LOCATION_DATA_BY_ADDRESS_SUCCESS',
  GET_LOCATION_DATA_BY_ADDRESS_FAILED = '[DEVICES] GET_LOCATION_DATA_BY_ADDRESS_FAILED',

  GET_AUTH_INFO_DEVICES = '[AUTH] AUTH_INFO_DEVICES',
  GET_AUTH_INFO_DEVICES_SUCCESS = '[AUTH] AUTH_INFO_DEVICES_SUCCESS',
  GET_AUTH_INFO_DEVICES_FAILED = '[AUTH] AUTH_INFO_DEVICES_FAILED',

  RESTART_DEVICE = '[DEVICES] RESTART_DEVICE',
  RESTART_DEVICE_SUCCESS = '[DEVICES] RESTART_DEVICE_SUCCESS',
  RESTART_DEVICE_FAILED = '[DEVICES] RESTART_DEVICE_FAILED',

  DELETE_DEVICE = '[DEVICES] DELETE_DEVICE',
  DELETE_DEVICE_SUCCESS = '[DEVICES] DELETE_DEVICE_SUCCESS',
  DELETE_DEVICE_FAILED = '[DEVICES] DELETE_DEVICE_FAILED',

  GET_DEVICE_TELEMETRY = '[DEVICES] GET_DEVICE_TELEMETRY',
  GET_DEVICE_TELEMETRY_SUCCESS = '[DEVICES] GET_DEVICE_TELEMETRY_SUCCESS',
  GET_DEVICE_TELEMETRY_FAILED = '[DEVICES] GET_DEVICE_TELEMETRY_FAILED',

  GET_CROSSNET_DEVICES = '[DEVICES] GET_CROSSNET_DEVICES',
  GET_CROSSNET_DEVICES_SUCCESS = '[DEVICES] GET_CROSSNET_DEVICES_SUCCESS',
  GET_CROSSNET_DEVICES_FAILED = '[DEVICES] GET_CROSSNET_DEVICES_FAILED',

  // Firmware management
  GET_DEVICE_FIRMWARE = '[FIRMWARE] GET_DEVICE_FIRMWARE',
  GET_DEVICE_FIRMWARE_SUCCESS = '[FIRMWARE] GET_DEVICE_FIRMWARE_SUCCESS',
  GET_DEVICE_FIRMWARE_FAILED = '[FIRMWARE] GET_DEVICE_FIRMWARE_FAILED',

  GET_MENDER_FIRMWARE = '[FIRMWARE] GET_MENDER_FIRMWARE',
  GET_MENDER_FIRMWARE_SUCCESS = '[FIRMWARE] GET_MENDER_FIRMWARE_SUCCESS',
  GET_MENDER_FIRMWARE_FAILED = '[FIRMWARE] GET_MENDER_FIRMWARE_FAILED',

  UPLOAD_DEVICE_FIRMWARE = '[FIRMWARE] UPLOAD_DEVICE_FIRMWARE',
  UPLOAD_DEVICE_FIRMWARE_SUCCESS = '[FIRMWARE] UPLOAD_DEVICE_FIRMWARE_SUCCESS',
  UPLOAD_DEVICE_FIRMWARE_FAILED = '[FIRMWARE] UPLOAD_DEVICE_FIRMWARE_FAILED',

  DELETE_DEVICE_FIRMWARE = '[FIRMWARE] DELETE_DEVICE_FIRMWARE',
  DELETE_DEVICE_FIRMWARE_SUCCESS = '[FIRMWARE] DELETE_DEVICE_FIRMWARE_SUCCESS',
  DELETE_DEVICE_FIRMWARE_FAILED = '[FIRMWARE] DELETE_DEVICE_FIRMWARE_FAILED',

  SET_DEVICE_FIRMWARE_METADATA = '[FIRMWARE] SET_DEVICE_FIRMWARE_METADATA',
  SET_DEVICE_FIRMWARE_METADATA_SUCCESS = '[FIRMWARE] SET_DEVICE_FIRMWARE_METADATA_SUCCESS',
  SET_DEVICE_FIRMWARE_METADATA_FAILED = '[FIRMWARE] SET_DEVICE_FIRMWARE_METADATA_FAILED',

  // This part is for the mender update
  GET_MENDER_RELEASES = '[MENDER] GET_MENDER_ARTIFACTS',
  GET_MENDER_RELEASES_SUCCESS = '[MENDER] GET_MENDER_ARTIFACTS_SUCCESS',
  GET_MENDER_RELEASES_FAILED = '[MENDER] GET_MENDER_ARTIFACTS_FAILED',

  GET_UPGRADE_STATUS = '[MENDER] GET_UPGRADE_STATUS',
  GET_UPGRADE_STATUS_SUCCESS = '[MENDER] GET_UPGRADE_STATUS_SUCCESS',
  GET_UPGRADE_STATUS_FAILED = '[MENDER] GET_UPGRADE_STATUS_FAILED',

  INSTALL_MENDER_ARTIFACT_FOR_DEVICES = '[MENDER] INSTALL_MENDER_ARTIFACT_FOR_DEVICES',
  INSTALL_MENDER_ARTIFACT_FOR_DEVICES_SUCCESS = '[MENDER] INSTALL_MENDER_ARTIFACT_FOR_DEVICES_SUCCESS',
  INSTALL_MENDER_ARTIFACT_FOR_DEVICES_FAILED = '[MENDER] INSTALL_MENDER_ARTIFACT_FOR_DEVICES_FAILED',
}

export const getDevicesAction = createAction(DevicesActionsTypes.GET_DEVICES, props<IDataAction<IGetDevicesData>>());
export const getDevicesSuccessAction = createAction(DevicesActionsTypes.GET_DEVICES_SUCCESS, props<IDataAction<{ query: IGetDevicesData, devices: BasicXpacInfo[] }>>());
export const getDevicesFailedAction = createAction(DevicesActionsTypes.GET_DEVICES_FAILED);
export const refreshDevicesAction = createAction(DevicesActionsTypes.REFRESH_DEVICES);

export const getUpgradeDevicesAction = createAction(DevicesActionsTypes.GET_UPGRADE_DEVICES, props<IDataAction<IGetUpgradeData>>());
export const getUpgradeDevicesSuccessAction = createAction(DevicesActionsTypes.GET_UPGRADE_DEVICES_SUCCESS,props<IDataAction<BasicXpacInfo[]>>());
export const getUpgradeDevicesFailedAction = createAction(DevicesActionsTypes.GET_UPGRADE_DEVICES_FAILED);

export const getRestoreDevicesAction = createAction(DevicesActionsTypes.GET_RESTORE_DEVICES,props<IDataAction<IGetRestoreDevicesData>>());
export const getRestoreDevicesSuccessAction = createAction(DevicesActionsTypes.GET_RESTORE_DEVICES_SUCCESS,props<IDataAction<IRestoreDevicesXpac>>());
export const getRestoreDevicesFailedAction = createAction(DevicesActionsTypes.GET_RESTORE_DEVICES_FAILED);

export const getMapDevicesAction = createAction(DevicesActionsTypes.GET_MAP_DEVICES,props<IDataAction<IGetMapDevicesData>>());
export const getMapDevicesSuccessAction = createAction(DevicesActionsTypes.GET_MAP_DEVICES_SUCCESS,props<IDataAction<BasicXpacInfo[]>>());
export const getMapDevicesFailedAction = createAction(DevicesActionsTypes.GET_MAP_DEVICES_FAILED);

export const setRestoreDevicesAction = createAction(DevicesActionsTypes.SET_RESTORE_DEVICE,props<IDataAction<ISetRestoreDevicesData>>());
export const setRestoreDevicesSuccessAction = createAction(DevicesActionsTypes.SET_RESTORE_DEVICE_SUCCESS);
export const setRestoreDevicesFailedAction = createAction(DevicesActionsTypes.SET_RESTORE_DEVICE_FAILED);

export const getDeviceProblemsAction = createAction(DevicesActionsTypes.GET_DEVICE_PROBLEMS,props<IDataAction<string>>());
export const getDeviceProblemsSuccessAction = createAction(DevicesActionsTypes.GET_DEVICE_PROBLEMS_SUCCESS,props<IDataAction<IProblemState>>());
export const getDeviceProblemsFailedAction = createAction(DevicesActionsTypes.GET_DEVICE_PROBLEMS_FAILED);

export const getDeviceLoggingAction = createAction(DevicesActionsTypes.GET_DEVICE_LOGGING, props<{data: {deviceId: string; maxLogs: number; continuationToken?: string; append?: boolean;}}>());
export const getDeviceLoggingSuccessAction = createAction(DevicesActionsTypes.GET_DEVICE_LOGGING_SUCCESS, props<{data: {deviceId: string; page: DeviceLogPageResponse; append: boolean;}}>());
export const getDeviceLoggingFailedAction = createAction(DevicesActionsTypes.GET_DEVICE_LOGGING_FAILED);

export const getDeviceCompaniesAction = createAction(DevicesActionsTypes.GET_DEVICE_COMPANIES,props<IDataAction<string>>());
export const getDeviceCompaniesSuccessAction = createAction(DevicesActionsTypes.GET_DEVICE_COMPANIES_SUCCESS,props<IDataAction<IXpacCompanyInfoState>>());
export const getDeviceCompaniesFailedAction = createAction(DevicesActionsTypes.GET_DEVICE_COMPANIES_FAILED);

export const setDeviceCompaniesAction = createAction(DevicesActionsTypes.SET_DEVICE_COMPANIES,props<IDataAction<IXpacCompanyInfoState>>());
export const setDeviceCompaniesSuccessAction = createAction(DevicesActionsTypes.SET_DEVICE_COMPANIES_SUCCESS,props<IDataAction<IXpacCompanyInfoState>>());
export const setDeviceCompaniesFailedAction = createAction(DevicesActionsTypes.SET_DEVICE_COMPANIES_FAILED);

export const getStoreInfoAction = createAction(DevicesActionsTypes.GET_STORE_INFO,props<IDataAction<string>>());
export const getStoreInfoSuccessAction = createAction(DevicesActionsTypes.GET_STORE_INFO_SUCCESS,props<IDataAction<DetailedXpacInfo>>());
export const getStoreInfoFailedAction = createAction(DevicesActionsTypes.GET_STORE_INFO_FAILED);

export const setStoreInfoAction = createAction(DevicesActionsTypes.SET_STORE_INFO,props<IDataAction<IPatchStoreState>>());
export const setStoreInfoSuccessAction = createAction(DevicesActionsTypes.SET_STORE_INFO_SUCCESS, props<IDataAction<IPatchStoreState>>());
export const setStoreInfoFailedAction = createAction(DevicesActionsTypes.SET_STORE_INFO_FAILED);

export const getLocationAutocompleteAction = createAction(DevicesActionsTypes.GET_LOCATION_AUTOCOMPLETE,props<IDataAction<string>>());
export const getLocationAutocompleteSuccessAction = createAction(DevicesActionsTypes.GET_LOCATION_AUTOCOMPLETE_SUCCESS,props<IDataAction<LocationHandle[]>>());
export const getLocationAutocompleteFailedAction = createAction(DevicesActionsTypes.GET_LOCATION_AUTOCOMPLETE_FAILED);

export const getLocationDataByAddressAction = createAction(DevicesActionsTypes.GET_LOCATION_DATA_BY_ADDRESS,props<IDataAction<string>>());
export const getLocationDataByAddressSuccessAction = createAction(DevicesActionsTypes.GET_LOCATION_DATA_BY_ADDRESS_SUCCESS,props<IDataAction<Address>>());
export const getLocationDataByAddressFailedAction = createAction(DevicesActionsTypes.GET_LOCATION_DATA_BY_ADDRESS_FAILED);

export const getRemoteConnectionsAction = createAction(DevicesActionsTypes.GET_REMOTE_CONNECTIONS,props<IDataAction<string>>());
export const getRemoteConnectionsSuccessAction = createAction(DevicesActionsTypes.GET_REMOTE_CONNECTIONS_SUCCESS,props<IDataAction<IRemoteConnectionsState>>());
export const getRemoteConnectionsFailedAction = createAction(DevicesActionsTypes.GET_REMOTE_CONNECTIONS_FAILED);

export const getDeviceConnectionsAction = createAction(DevicesActionsTypes.GET_DEVICE_CONNECTIONS,props<IDataAction<string>>());
export const getDeviceConnectionsSuccessAction = createAction(DevicesActionsTypes.GET_DEVICE_CONNECTIONS_SUCCESS,props<IDataAction<IDeviceConnectionsState>>());
export const getDeviceConnectionsFailedAction = createAction(DevicesActionsTypes.GET_DEVICE_CONNECTIONS_FAILED);

export const getAuthInfoDevicesAction = createAction(DevicesActionsTypes.GET_AUTH_INFO_DEVICES);
export const getAuthInfoDevicesSuccessAction = createAction(DevicesActionsTypes.GET_AUTH_INFO_DEVICES_SUCCESS, props<IDataAction<ApiPermissions>>());
export const getAuthInfoDevicesFailedAction = createAction(DevicesActionsTypes.GET_AUTH_INFO_DEVICES_FAILED);

export const restartDeviceAction = createAction(DevicesActionsTypes.RESTART_DEVICE, props<IDataAction<string>>());
export const restartDeviceSuccessAction = createAction(DevicesActionsTypes.RESTART_DEVICE_SUCCESS, props<IDataAction<string>>());
export const restartDeviceFailedAction = createAction(DevicesActionsTypes.RESTART_DEVICE_FAILED, props<IDataAction<string>>());

export const deleteDeviceAction = createAction(DevicesActionsTypes.DELETE_DEVICE,props<IDataAction<string>>());
export const deleteDeviceSuccessAction = createAction(DevicesActionsTypes.DELETE_DEVICE_SUCCESS);
export const deleteDeviceFailedAction = createAction(DevicesActionsTypes.DELETE_DEVICE_FAILED);

export const getDeviceTelemetryAction = createAction(DevicesActionsTypes.GET_DEVICE_TELEMETRY, props<IDataAction<IGetTelemetry>>());
export const getDeviceTelemetrySuccessAction = createAction(DevicesActionsTypes.GET_DEVICE_TELEMETRY_SUCCESS, props<IDataAction<ITelemetryState>>());
export const getDeviceTelemetryFailedAction = createAction(DevicesActionsTypes.GET_DEVICE_TELEMETRY_FAILED, props<IDataAction<string>>());

export const getXpacDevicesAction = createAction(DevicesActionsTypes.GET_CROSSNET_DEVICES, props<IDataAction<string>>());
export const getXpacDevicesSuccessAction = createAction(DevicesActionsTypes.GET_CROSSNET_DEVICES_SUCCESS, props<IDataAction<IXpacDevices>>());
export const getXpacDevicesFailedAction = createAction(DevicesActionsTypes.GET_CROSSNET_DEVICES_FAILED, props<IDataAction<string>>());

// Firmware
export const getDeviceFirmwareAction = createAction(DevicesActionsTypes.GET_DEVICE_FIRMWARE);
export const getDeviceFirmwareSuccessAction = createAction(DevicesActionsTypes.GET_DEVICE_FIRMWARE_SUCCESS, props<IDataAction<RemoteFirmwareInformation[]>>());
export const getDeviceFirmwareFailedAction = createAction(DevicesActionsTypes.GET_DEVICE_FIRMWARE_FAILED);

export const uploadDeviceFirmwareAction = createAction(DevicesActionsTypes.UPLOAD_DEVICE_FIRMWARE, props<IDataAction<Blob>>());
export const uploadDeviceFirmwareSuccessAction = createAction(DevicesActionsTypes.UPLOAD_DEVICE_FIRMWARE_SUCCESS, props<IDataAction<RemoteFirmwareInformation>>());
export const uploadDeviceFirmwareFailedAction = createAction(DevicesActionsTypes.UPLOAD_DEVICE_FIRMWARE_FAILED);

export const deleteDeviceFirmwareAction = createAction(DevicesActionsTypes.DELETE_DEVICE_FIRMWARE, props<IDataAction<string>>());
export const deleteDeviceFirmwareSuccessAction = createAction(DevicesActionsTypes.DELETE_DEVICE_FIRMWARE_SUCCESS, props<IDataAction<string>>());
export const deleteDeviceFirmwareFailedAction = createAction(DevicesActionsTypes.DELETE_DEVICE_FIRMWARE_FAILED, props<IDataAction<string>>());

export const setFirmwareMetadataAction = createAction(DevicesActionsTypes.SET_DEVICE_FIRMWARE_METADATA, props<IDataAction<IFirmwareInfoPatch>>());
export const setFirmwareMetadataSuccessAction = createAction(DevicesActionsTypes.SET_DEVICE_FIRMWARE_METADATA_SUCCESS, props<IDataAction<IFirmwareInfoPatch>>());
export const setFirmwareMetadataFailedAction = createAction(DevicesActionsTypes.SET_DEVICE_FIRMWARE_METADATA_FAILED, props<IDataAction<IFirmwareInfoPatch>>());

// Mender part
export const getMenderReleasesAction = createAction(DevicesActionsTypes.GET_MENDER_RELEASES, props<IDataAction<IGetMenderReleasesState>>());
export const getMenderReleasesSuccessAction = createAction(DevicesActionsTypes.GET_MENDER_RELEASES_SUCCESS, props<IDataAction<Release[]>>());
export const getMenderReleasesFailedAction = createAction(DevicesActionsTypes.GET_MENDER_RELEASES_FAILED);

export const getUpgradeStatusAction = createAction(DevicesActionsTypes.GET_UPGRADE_STATUS, props<IDataAction<string[]>>());
export const getUpgradeStatusSuccessAction = createAction(DevicesActionsTypes.GET_UPGRADE_STATUS_SUCCESS,props<IDataAction<IDeviceDeployments[]>>());
export const getUpgradeStatusFailedAction = createAction(DevicesActionsTypes.GET_UPGRADE_STATUS_FAILED, props<IDataAction<string[]>>());

export const installMenderArtifactForDevicesAction = createAction(DevicesActionsTypes.INSTALL_MENDER_ARTIFACT_FOR_DEVICES,props<IDataAction<UpgradeData>>());
export const installMenderArtifactForDevicesSuccessAction = createAction(DevicesActionsTypes.INSTALL_MENDER_ARTIFACT_FOR_DEVICES_SUCCESS);
export const installMenderArtifactForDevicesFailedAction = createAction(DevicesActionsTypes.INSTALL_MENDER_ARTIFACT_FOR_DEVICES_FAILED);